<div class="loading-indicator" *ngIf="loading">
  <mat-progress-spinner
    mode="indeterminate"
    color="primary"
  ></mat-progress-spinner>
</div>

<div
  mat-dialog-title
  class="modal-title"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle
>
  <span class="modal-title-label">{{ getTitle() }}</span>
  <button
    class="modal-close-button"
    mat-icon-button
    matTooltip="{{ httpService.getTransation().Close }}"
    (click)="onCancel()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content class="pt-1">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <mat-form-field fxFlex="50" style="padding-right: 8px">
      <mat-select
        placeholder="{{ httpService.getTransation().SelectACategory }}"
        [(value)]="selectedCategory"
        (selectionChange)="onCategorySelected(selectedCategory)"
      >
        <mat-option *ngFor="let c of categories" [value]="c"
          >{{ c.name }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <mat-form-field fxFlex="50" style="padding-left: 8px">
      <input
        type="text"
        matInput
        placeholder="{{ httpService.getTransation().SearchPattern }}"
        [(ngModel)]="searchFilter"
        appDelayedChange
        (delayedChange)="onSearchDelayedChange($event)"
      />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
  <mat-radio-group
    class="pattern-list"
    [(ngModel)]="selectedPattern"
    [style.height]="(modalHeight - 235) + 'px'"
  >
    <mat-radio-button
      class="pattern-card"
      *ngFor="let p of patterns"
      [value]="p"
      (dblclick)="onPatternDoubleClick()"
    >
      <div class="pattern-card-content">
        <div class="pattern-info">
          <div class="pattern-row-1">
            <strong class="pattern-name">{{ p.name }}</strong>
            <div class="pattern-badges">
              <span class="badge badge-dim" *ngIf="getPatternDimensions(p)">{{ getPatternDimensions(p) }}</span>
              <span class="badge badge-stitch" *ngIf="getStitchName(p)">{{ getStitchName(p) }}</span>
            </div>
          </div>
          <div class="pattern-row-2" *ngIf="p.categoryName || getBeadTypeName(p) || p.description">
            <span class="meta-tag" *ngIf="p.categoryName">{{ p.categoryName }}</span>
            <span class="meta-tag bead-type" *ngIf="getBeadTypeName(p)">{{ getBeadTypeName(p) }}</span>
            <span class="meta-desc" *ngIf="p.description">{{ p.description }}</span>
          </div>
        </div>
        <div class="pattern-actions">
          <button
            mat-icon-button
            title="{{ httpService.getTransation().EditPattern }}"
            (click)="onEditPattern(p); $event.stopPropagation()"
          >
            <mat-icon>edit</mat-icon>
          </button>
          <button
            mat-icon-button
            title="{{ httpService.getTransation().DeletePattern }}"
            (click)="onDeletePattern(p); $event.stopPropagation()"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </mat-radio-button>
  </mat-radio-group>
</div>
<div mat-dialog-actions align="end" *ngIf="!loading">
  <button
    mat-raised-button
    color="primary"
    [mat-dialog-close]="selectedPattern"
    [disabled]="!selectedPattern"
  >
    {{ httpService.getTransation().Ok }}
  </button>
  <button mat-raised-button cdkFocusInitial (click)="onCancel()">
    {{ httpService.getTransation().Cancel }}
  </button>
</div>
